import React, { memo } from "react";

import { StyledChip } from "./styles/Chip";

const Chip = ({
  productHeader = false,
  bgcolor,
  textcolor,
  label,
  spacing = "12",
  error,
  icon,
  title = "",
  ...props
}) => {
  return (
    <StyledChip
      {...props}
      $productHeader={productHeader}
      label={label}
      textcolor={error ? "white" : textcolor}
      bgcolor={error ? "red" : bgcolor}
      spacing={spacing}
      title={title}
    />
  );
};

export default memo(Chip);
